export default "__VITE_ASSET__3e5f08ab__"